var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-wrapper" },
    [
      _c(
        "v-form",
        _vm._b(
          {
            on: { validate: _vm.validateStep, submit: _vm.validateAll },
            scopedSlots: _vm._u([
              {
                key: "step-0",
                fn: function() {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.designer,
                          expression: "form.designer"
                        }
                      ],
                      attrs: {
                        name: "designer",
                        id: "designer",
                        placeholder: _vm.translation.designer
                      },
                      domProps: { value: _vm.form.designer },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "designer", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.furniture_type,
                          expression: "form.furniture_type"
                        }
                      ],
                      attrs: {
                        name: "type",
                        id: "type",
                        placeholder: _vm.translation.mobel
                      },
                      domProps: { value: _vm.form.furniture_type },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.form,
                            "furniture_type",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.measurements,
                          expression: "form.measurements"
                        }
                      ],
                      attrs: {
                        name: "size",
                        type: "text",
                        placeholder: _vm.translation.size
                      },
                      domProps: { value: _vm.form.measurements },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.form,
                            "measurements",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.files_error,
                              expression: "files_error"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_missing))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        ref: "myFiles",
                        attrs: {
                          name: "upload",
                          type: "file",
                          id: "upload",
                          accept: "image/png, image/jpeg",
                          multiple: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.uploadfiles()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "input-placeholder",
                          on: { click: _vm.openUpload }
                        },
                        [
                          _vm.files.length == 0
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.translation.no_files) +
                                    "\n          "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.translation.success_files) +
                                    " (" +
                                    _vm._s(_vm.files.length) +
                                    ")"
                                )
                              ])
                        ]
                      )
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "step-1",
                fn: function() {
                  return [
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form-2.name"),
                              expression: "errors.has('form-2.name')"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_missing))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.name,
                            expression: "form.name"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          id: "name",
                          name: "name",
                          placeholder: _vm.translation.name,
                          "data-vv-scope": "form-2"
                        },
                        domProps: { value: _vm.form.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "name", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form-2.postnumber"),
                              expression: "errors.has('form-2.postnumber')"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_missing))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.address,
                            expression: "form.address"
                          }
                        ],
                        attrs: {
                          id: "postnumber",
                          name: "postnumber",
                          placeholder: _vm.translation.postnumber,
                          "data-vv-scope": "form-2"
                        },
                        domProps: { value: _vm.form.address },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "address", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form-2.phone"),
                              expression: "errors.has('form-2.phone')"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_missing))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric",
                            expression: "'required|numeric'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.phone,
                            expression: "form.phone"
                          }
                        ],
                        key: "phone-input",
                        attrs: {
                          id: "phone",
                          name: "phone",
                          placeholder: _vm.translation.phone,
                          "data-vv-scope": "form-2"
                        },
                        domProps: { value: _vm.form.phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "phone", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("form-2.email"),
                              expression: "errors.has('form-2.email')"
                            }
                          ],
                          staticClass: "form-error"
                        },
                        [_vm._v(_vm._s(_vm.translation.error_field_missing))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.email,
                            expression: "form.email"
                          }
                        ],
                        key: "email-input",
                        attrs: {
                          id: "email",
                          name: "email",
                          placeholder: _vm.translation.email,
                          "data-vv-scope": "form-2"
                        },
                        domProps: { value: _vm.form.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "email", $event.target.value)
                          }
                        }
                      })
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "step-2",
                fn: function() {
                  return [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.message,
                          expression: "form.message"
                        }
                      ],
                      attrs: {
                        name: "comment",
                        placeholder: _vm.translation.comment
                      },
                      domProps: { value: _vm.form.message },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "message", $event.target.value)
                        }
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          },
          "v-form",
          {
            steps: _vm.steps,
            text_top: _vm.text_top,
            text_bottom: _vm.text_bottom,
            type: _vm.type,
            form: _vm.form,
            terms: _vm.terms
          },
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }